import { render } from "./ProductsPage.vue?vue&type=template&id=f670e88e&scoped=true"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"

import "./ProductsPage.vue?vue&type=style&index=0&id=f670e88e&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f670e88e"]])

export default __exports__